exports.cs = {
  CSPS_MILLION_CHILD: {
    DATE_BIRTH_LABEL: 'Datum narození dítěte:',
    DATE_START_LABEL: 'Datum kdy mu začnete spořit:',
    MONTHLY_SAVINGS: 'Měsíčně budete spořit:',
    CONTRIBUTION: 'Měsíčně vám přispěje zaměstnavatel:',
    INIT_DEPOSIT: 'Jednorázově vložíte:',
    ANNUAL_YIELD: 'Předpokládané roční zhodnocení:',
    ANNUAL_YIELD_TOOLTIP: '1% pro Konzervativní fond, 4% pro Vyvážený fond, 6% pro Dynamický fond',
    TOTAL_EXPECTED_SAVINGS: 'Celková výše naspořených prostředků v 18 letech:',
    EIGHTEEN_WITHDRAWAL: 'Výše prostředků, které lze v 18 letech vybrat:',
    PARTICIPANT_CONTRIBUTION: 'Celkové příspěvky účastníka:',
    EMPLOYER_CONTRIBUTION: 'Celkové příspěvky zaměstnavatele:',
    STATE_CONTRIBUTION: 'Celkové státní příspěvky:',
    EXTRA_INCOME: 'Celkové výnosy:',
    ORDER_ONLINE: 'Sjednat online',
    ORDER_ONLINE_MESSAGE: 'V klidu a z pohodlí vašeho domova. Stačí pár kliknutí myší.',
    CALL_ME: 'Zavolejte mi',
    CALL_ME_MESSAGE: 'Rádi se s vámi uslyšíme. Nechte nám na sebe kontakt, ozveme se.',
    HINT: {
      LABEL: 'TIP',
      TEXT: 'Pro výběr částečného odbytného je potřeba splnit minimálně 120 měsíců spoření.'
    }
  },
  CZK: 'Kč',
  PLURAL: {
    YEARS: 'rok |||| roky |||| let'
  },
  MONTH_NAMES: {
    1: 'Leden',
    2: 'Únor',
    3: 'Březen',
    4: 'Duben',
    5: 'Květen',
    6: 'Červen',
    7: 'Červenec',
    8: 'Srpen',
    9: 'Září',
    10: 'Říjen',
    11: 'Listopad',
    12: 'Prosinec'
  }
}
